import React from "react";
import ReactDOM from 'react-dom/client';
import AkontacijaStrana from "./akontacijaStrana";

const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Putni nalog - Štampa</title>
          <style>
            
            .paragraph{margin: 50px 0 50px 0;font-size:11pt;line-height:1.35;text-align:justify}
            .title {text-align:center}
          *{box-sizing:border-box}
      html,body{margin:0;padding:0;font-family:Arial, sans-serif;font-size:11pt;color:#000}
      @page{size:A4 portrait;margin:0}
      #print-root{page:auto;position:relative;min-height:100vh}


      .print-page{width:210mm;position:relative;display:block;page-break-inside:avoid;padding:20mm 30mm}
      .print-page:not(:last-child){page-break-after:always}


      /* Header/top */
      .top-row{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8mm}
      .broj{font-size:12pt}
      .firma{text-align:center}
      .firma .naziv{font-size:25px;font-weight:700}
      .firma .mesto{font-size:25px; margin-top: 0;}


      .titleBox {
      width: 100%;
      display:flex;
      align-items:center;
      justify-content: center;
      }
      .title{font-size:30px;font-weight:700;text-align:center;margin:0 0 30mm 0;width:fit-content;border-bottom: 1px solid;}

      .mp{    position: absolute;
          width: 10px !important;
          left: 30%;
          top: 50%;
          margin-top:6px}
      .meta{margin:0 0 4mm 0;font-size:20px;font-weight: 700;margin-top:300px;margin-bottom: 50px;}
      .meta span {
      border-bottom: 1px solid;
      }
      .paragraph{margin: 50px 0 50px 0;font-size:25px;line-height:1.35;text-align:justify}


      .sign-row{position:absolute;left:30mm;right:30mm;display:grid;grid-template-columns:1fr 1fr 1fr;gap:30mm;}
      .sign-block{display:flex;flex-direction:column;align-items:center;justify-content:flex-end;font-size:larger;}
      .sign-title{font-weight:700;margin-bottom:20px}
      .sign-line{margin-top:28px;border-top:1px solid #000;width:100%}


      @media print{
      *{-webkit-print-color-adjust:exact;print-color-adjust:exact}
      }
                </style>
              </head>
              <body>
                <div id="print-content"></div>
              </body>
            </html>
    `;
export default function handlePrintAcontation(podaci) {
  
    const printWindow = window.open('', '_blank', 'width=1000,height=700');

    printWindow.document.open();
    printWindow.document.write(printContent);
    const styleEl = printWindow.document.createElement("style");
    styleEl.textContent = `
  /* A4 landscape bez margina printera */
  @page { size: A4 portrait; margin: 0; }
  html, body { margin: 0; padding: 0; }

  /* Svaka strana je tačno A4 landscape "page box" */
  .print-page {
    position: relative;
    display: block;
    width: 297mm;
    height: 210mm;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  /* 1. strana – tvoje postojeće margine rešavaj padding-om kontejnera */
  .print-page.first { padding: 0.75in 0.7in; }

  /* 2. strana – počinje na novoj strani */
  .print-page.second {
    break-before: page;
    page-break-before: always;
    padding: 0;
  }

  /* === 5% "padding" oko DRUGE strane (tačno u mm) ===
     5% od 297mm = 14.85mm levo/desno, 5% od 210mm = 10.5mm gore/dole */
  .pg2-viewport {
    position: absolute;
    left: 14.85mm;
    top: 10.5mm;
    width: calc(297mm - 29.7mm);   /* 297 - 2*14.85 = 267.3mm */
    height: calc(210mm - 21mm);    /* 210 - 2*10.5 = 189mm */
    overflow: hidden;
  }

  /* Rotirani "kanvas" bez skaliranja: 0.9 * portret A4 => 189 x 267.3mm
     Rotacijom -90° postaje 267.3 x 189 i savršeno staje u pg2-viewport */
  .rot-fit {
    position: absolute;
    top: 50%; left: 50%;
    width: 189mm;         /* = 0.9 * 210mm */
    height: 267.3mm;      /* = 0.9 * 297mm */
    transform: translate(-50%, -50%) rotate(-90deg);
  }

  /* Tabela zauzima ceo rotirani kanvas */
  .rotated-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
  .rotated-table col { width: calc(100% / 24); }

  .rotated-table td {
    border: 0.25mm solid #000;
    padding: 2px;
    box-sizing: border-box;
    overflow: hidden;
  }

  /* Fiksni redovi od 25px: prva 3 i poslednja 4 */
  .row25 td {
    height: 25px !important;
    max-height: 25px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    white-space: nowrap;
  }
   :root{
  --pg2-fixed-row-h: 25px;   /* fiksna visina za header/footer redove */
  --pg2-header-rows: 3;      /* prva 3 reda */
  --pg2-footer-rows: 4;      /* poslednja 4 reda */
  --body-rows: 18;           /* <- BROJ srednjih redova koji treba da se rastegnu (promeni po potrebi!) */
}

/* Tabela na drugoj strani N E K A bude tačno H=100% prostora rot-fit-a */
.rotated-table{
  width: 100%;
  height: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

/* Fiksni redovi (header/footer) – ne smeju da rastu */
.row25 td{
  height: var(--pg2-fixed-row-h) !important;
  max-height: var(--pg2-fixed-row-h) !important;
  line-height: var(--pg2-fixed-row-h) !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  white-space: nowrap;
  overflow: hidden;
}

/* R A S T E G L J I V I redovi u sredini – ravnomerno podele preostalu visinu */
.grow-row td{
  height: calc(
    (100% - (var(--pg2-header-rows) + var(--pg2-footer-rows)) * var(--pg2-fixed-row-h))
    / var(--body-rows)
  ) !important;
  /* bez line-height-a, da sadržaj normalno stoji */
}
`;
    printWindow.document.head.appendChild(styleEl);
    printWindow.document.close();

    const printDocument = printWindow.document;
    const printContainer = printDocument.getElementById('print-content');

    const { createRoot } = ReactDOM;
    const root = createRoot(printContainer);

    root.render(
      <>
        {/* Prva strana - simulacija landscape */}
        <div className="landscape-wrapper">
          <AkontacijaStrana podaci={podaci} />
        </div>
        {/* <div className="second-page">
          <PutniNalogZaStampu2 page={1} scale={2} pdfUrl={pdfPage} />
        </div> */}
        {/* Druga strana - normalno portrait */}
        
      </>
    );

    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
    }, 500);

};